import { render, staticRenderFns } from "./CreateAnnotationButton.vue?vue&type=template&id=17864d8a&scoped=true"
import script from "./CreateAnnotationButton.vue?vue&type=script&lang=ts"
export * from "./CreateAnnotationButton.vue?vue&type=script&lang=ts"
import style0 from "./CreateAnnotationButton.vue?vue&type=style&index=0&id=17864d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17864d8a",
  null
  
)

export default component.exports